import { useId, useState, type ReactNode } from "react";

export function Chevron() {
  return (
    <svg className="disclosure-chevron" viewBox="0 0 12 12" aria-hidden="true">
      <path d="M2 4.5l4 4 4-4" fill="none" stroke="currentColor" strokeWidth="1.6" />
    </svg>
  );
}

/** A disclosure (button + region), not a dialog. Controlled with open/onToggle or uncontrolled with defaultOpen. */
export function Disclosure({ summary, children, defaultOpen = false, open: openProp, onToggle, className, meta }: {
  summary: ReactNode;
  children: ReactNode;
  defaultOpen?: boolean;
  open?: boolean;
  onToggle?: (open: boolean) => void;
  className?: string;
  meta?: ReactNode;
}) {
  const [own, setOwn] = useState(defaultOpen);
  const open = openProp ?? own;
  const id = useId();
  return (
    <div className={`disclosure${className ? ` ${className}` : ""}`}>
      <button type="button" className="disclosure-toggle" aria-expanded={open} aria-controls={id} onClick={() => { setOwn(!open); onToggle?.(!open); }}>
        <span>{summary}</span>
        <span className="row">{meta}<Chevron /></span>
      </button>
      <div id={id} className="disclosure-body" hidden={!open}>{children}</div>
    </div>
  );
}
